import apiInstance from "./index";

/**
 * Secondary-role scope memberships (Service Manager, Technician, …). Each
 * row carries `scopeKind`, `userProfileId`, an optional
 * `defaultLocationId` + `defaultLocationName`, and join metadata
 * (`firstName`, `lastName`, `email`).
 */
export const OrgRoleScopesService = {
  /**
   * GET /api/organization-role-scopes?scopeKind=service_manager
   * → all members of that scope in the caller's org. Used by the
   * "Manage members" modal.
   */
  list: (scopeKind) =>
    apiInstance.get("/organization-role-scopes", { params: { scopeKind } }),

  /**
   * GET /api/organization-role-scopes/me
   * → role-scope memberships the calling user holds in their current org
   * (across all scopeKinds). Used to auto-preselect the default
   * location on pages like /afms/settings/assets.
   */
  listMine: () => apiInstance.get("/organization-role-scopes/me"),
};

export default OrgRoleScopesService;
